import { Injectable } from '@angular/core';
import Axios from 'axios' ;
import { BankDto } from '../models/dtos/bankDto';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';


@Injectable({
    providedIn: 'root',
})
export class BankService {
 
    constructor(private http: HttpClient) { }
      
    public apiUrl = `${environment.apiUrl}/AdminDatas/`;

    private getHeaders() {
        const token = sessionStorage.getItem('token');
        return {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        };
    }
    
    async getBankaInfo(): Promise<BankDto[]> {
        const { data } = await Axios.get(`${this.apiUrl}getOdeme`, {
            headers: this.getHeaders()
        });
        return data;
    }

}